import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductEfficiencyComponent } from './product-efficiency.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ProductEfficiencyComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TabEfficiency: {
          component: ProductEfficiencyComponent,
        },
      },
    }),
  ],
})
export class ProductEfficiencyModule {}
